import React, { FC } from 'react';
import type { ChatMessage } from '../../types';
import { ReactComponent as OnlyLogoIcon } from 'src/assets/images/onboarding-trainer/components/sidebar/only-logo.svg';
import './PackageActiveBanner.scss';

interface PackageActiveBannerProps {
  message?: ChatMessage;
  clientName?: string;
  packageName?: string;
}

export const PackageActiveBanner: FC<PackageActiveBannerProps> = ({
  message,
  clientName,
  packageName,
}) => {
  // Determine client's display first name
  const rawClientName = message?.client_name || clientName || 'Client';
  const firstName = rawClientName.trim().split(/\s+/)[0] || 'Client';

  // Determine package name and strip redundant "Package" word if present
  const rawPkgName = message?.package_name || packageName || 'Basic';
  const cleanPkgName = rawPkgName.replace(/\s*package\s*/i, '').trim() || 'Basic';

  return (
    <div className="package-active-banner-row">
      <div className="package-active-pill">
        <OnlyLogoIcon className="package-active-logo" />
        <span className="package-active-text">
          {`${firstName}’s ${cleanPkgName} package is now `}
          <strong>active</strong>
        </span>
      </div>
    </div>
  );
};

